export class DebitoAutomaticoContratoDados {
  /**
   * Numero da Agência
   */
  codigoAgenciaBancaria: number;
  /**
   * Numero da Conta
   */
  codigoContaCorrente: number;
  /**
   * Digito da Conta
   */
  digitoContaCorrente: string;

  cdMsgemRetorno: string;
  dsMsgemRetorno: string;

  constructor() { }
}


// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/modelo/debito-automatico-contrato-dados.ts